import { render, staticRenderFns } from "./Footnote.vue?vue&type=template&id=70b8ea5e&lang=pug&"
import script from "./Footnote.vue?vue&type=script&lang=js&"
export * from "./Footnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports